import { Component, Input, Output, EventEmitter } from '@angular/core';
import { User } from '@app/core/models/user/user.model';
import { ResolutionService } from '@app/core/services/resolution/resolution.service';
import { AppState } from '@app/store/store.states';
import { Store } from '@ngrx/store';
import { LogOut } from '@app/store/auth/auth.actions';

@Component({
  selector: 'app-right-header-side',
  templateUrl: './right-header-side.component.html',
  styleUrls: ['./right-header-side.component.scss'],
})
export class RightHeaderSideComponent {
  @Input() currentUser: User;

  @Input() isMenuOpen = false;

  @Input() links: any;

  @Output() toggleUserProfileMenu = new EventEmitter<void>();

  @Output() closeUserProfileMenu = new EventEmitter<void>();

  constructor(
    private readonly resolutionService: ResolutionService,
    private readonly store: Store<AppState>
  ) {}

  toggleMenu(): void {
    this.toggleUserProfileMenu.emit();
  }

  logOut() {
    this.store.dispatch(new LogOut());
  }

  get displayDropdownMenu(): boolean {
    return !this.resolutionService.isTablet;
  }
}
